import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal, Form, FormGroup } from 'react-bootstrap';
import Button from '../ui/Button';
import { downloadExportFile } from '../../utils/uiUtils';
import { createPDFExportURL } from '../../utils/umoUtils';

/* eslint-disable jsx-a11y/label-has-for */
class PdfDownloadDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      error: null,
      isSuccess: false,
      itemsPerPage: 4,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  onFormSubmit(e) {
    e.preventDefault();

    downloadExportFile(createPDFExportURL(this.props.umoList, this.props.workspaceID,
      this.state.itemsPerPage, this.props.isSelectAll), false);

    this.props.addMessage('umoModifyDialog.inProgressMessage');
    this.props.hideUMOModifyDialog();
  }

  render() {
    return (
      <div className="workspace-dialog__form">
        <div className="workspace-dialog__form-header">
          {this.props.intl.formatMessage({ id: 'workspaceDownloadDialog.mainTitle' })}
          <br />
          <br />
          <div className="workspace-dialog__form-header-sub">
            {this.props.intl.formatMessage({ id: 'workspaceDownloadDialog.pdfDownloadTitle' })}
          </div>
          <br />
        </div>
        <Form onSubmit={this.onFormSubmit}>
          <FormGroup>
            <label className="control-label">
              {this.props.intl.formatMessage({ id: 'workspaceDownloadDialog.optionsItemsPerPage' })}
            </label>
            <select
              className="form-control"
              name="ItemsPP"
              value={this.state.itemsPerPage}
              onChange={(e) => { this.setState({ itemsPerPage: e.target.value }); }}
              style={{ width: 'fit-content' }}
            >
              <option key={1} value={1}>{1}</option>
              <option key={2} value={2}>{2}</option>
              <option key={4} value={4}>{4}</option>
              <option key={6} value={6}>{6}</option>
            </select>
          </FormGroup>
          <Modal.Footer>
            <Button onClick={this.props.onCloseClick}>
              {this.props.intl.formatMessage({ id: 'umoModifyDialog.buttonCancel' })}
            </Button>

            <Button primary type="submit">
              {this.props.intl.formatMessage({ id: 'workspaceDownloadDialog.buttonDownload' })}
            </Button>
          </Modal.Footer>
        </Form>
      </div>
    );
  }
}

PdfDownloadDialog.propTypes = {
  hideUMOModifyDialog: PropTypes.func,
  umoList: PropTypes.instanceOf(Array),
  workspaceID: PropTypes.string,
  addMessage: PropTypes.func,
  onCloseClick: PropTypes.func,
  isSelectAll: PropTypes.bool,
};

export default injectIntl(PdfDownloadDialog);



// WEBPACK FOOTER //
// ./src/js/components/UMOModifyDialog/PdfDownloadDialog.jsx